import { Link } from "react-router-dom";
import { Seo } from "@/lib/Seo";
import { btnPrimary } from "@/lib/ui";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Pagina niet gevonden | Brandpreventie Recycling"
        description="Deze pagina bestaat niet of is verplaatst."
      />
      <section className="flex min-h-[100svh] flex-col items-center justify-center px-4 text-center" data-testid="not-found-page">
        <p className="font-heading text-8xl font-extrabold text-outline">404</p>
        <h1 className="mt-4 font-heading text-3xl font-bold tracking-tight text-[#F5F7F9] sm:text-4xl">
          Deze pagina is niet gevonden
        </h1>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-[#CBD3D9]/80">
          De pagina die u zoekt bestaat niet of is verplaatst. Ga terug naar de homepage of vraag
          direct een locatieanalyse aan.
        </p>
        <Link to="/" className={`${btnPrimary} mt-8`} data-testid="not-found-home-btn">
          Naar de homepage <ArrowRight size={16} />
        </Link>
      </section>
    </>
  );
}
